import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import "./timeOverModal.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TimeOverModal = ({ open, onClose }) => {
  return (
    <div className="timeOverModal">
      <Dialog
        open={!!open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="timeOverModal-wrapper">
          <div className="timeOverModal-header">
            <h2>Time Over !!!</h2>
          </div>
          <div className="timeOverModal-content">
            <p>You can't change the prediction now.</p>
          </div>

          <div className="timeOverModal-button-wrapper">
            <Button onClick={onClose} className="timeOverModal-login-btn">
              GOT IT
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default TimeOverModal;
